import { useSelector } from 'react-redux';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';

const useFeatures = () => {
  const features = useSelector(loggedInUserSelectors.features);
  return { features };
};

export default useFeatures;
